const SERVER = {
  mock: 'http://127.0.0.1:3000/',
  stg: 'http://sg-stream-api-stg.lalamove.com/',
  pre: 'http://sg-stream-api-pre.lalamove.com/',
  prd: '/',
};

module.exports = {
  devServer: {
    proxy: {
      '/api': {
        target: SERVER.mock,
        changeOrigin: true,
        pathRewrite: {}
      }
    },
    host: '0.0.0.0',
    port: '8080',
    open: true,
  },
  baseURL: process.env.NODE_ENV === 'production' ? SERVER.prd : '/',
}
